import * as sentry from "./sentry"
import configClient from "../../api/hooks/config-client"

export const apiBaseURL = "/tibiapi/"
// export const baseURL = "https://tibi_starter.code.testversion.online.de"
export const release = configClient.release

export const sentryDSN = ""
export const sentryTracingOrigins = ["localhost", "project-domain.tld", /^\//]
export const sentryEnvironment: string = "${GITHUB_REF_NAME}"
// need to execute early for fetch wrapping
// sentry.init(sentryDSN, sentryTracingOrigins, sentryEnvironment, release)
